import * as React from 'react'

import { MyLoansQueryResult, Loan } from '../../components/queries/MyLoansQuery'
import { loan as commons } from '../../components/DatagridCommons'
import { Datagrid, IDefinition } from '../../components/Datagrid'

type UserLoansTableProps = {
  loans: MyLoansQueryResult['user']['loans']
}

const definition: IDefinition<Loan> = {
  columns: [
    commons.columns.date,
    commons.columns.creditorDebtors,
    commons.columns.description,
    commons.columns.loanedAmount,
    commons.columns.payed,
    commons.columns.toPay,
    commons.columns.detailAction
  ],
  idGetter: data => data.id,
  defaultSort: 'date',
  rowContainer: commons.rowContainer
}

const UserLoansTable: React.SFC<UserLoansTableProps> = ({
  loans
}) => <Datagrid definition={definition} data={loans} />

export default UserLoansTable



// WEBPACK FOOTER //
// ./src/screens/dashboard/AdminClosedLoansTable.tsx